interface Item {
    id: string;
    name: string;
    selected?: boolean;
    description?: string;
    land?: string;
};

export const cruisesearchTypes: Item[] = [
    {
        name: 'Hochsee (mit und ohne Flug)',
        id: 'K'
    },
    {
        name: 'Hochsee + Flug',
        id: 'S'
    },
    {
        name: 'Hochsee (ohne Flug)',
        id: 'NS'
    },
    {
        name: 'Nur Fluss',
        id: 'R'
    },
    {
        name: 'Hochsee + Flug + Hotel',
        id: 'KOMBI'
    },
];

export const cruisereiseDauer: Item[] = [
    {
        name: 'kürzer als 6 Tage',
        id: '1-5'
    },
    {
        name: '6 bis 9 Tage',
        id: '6-9'
    },
    {
        name: '10 bis 15 Tage',
        id: '10-15'
    },
    {
        name: 'länger als 15 Tage',
        id: '16-999'
    },
];

export const cruisemaxPass: Item[] = [
    {
        name: '500',
        id: '500'
    },
    {
        name: '1000',
        id: '1000'
    },
    {
        name: '2000',
        id: '2000'
    },
    {
        name: '3000',
        id: '3000'
    },
    {
        name: '4000',
        id: '4000'
    },
    {
        name: '5000',
        id: '5000'
    },
];

export const cruisecabinCat: Item[] = [
    {
        name: 'Min. Innenkabine',
        id: '1'
    },
    {
        name: 'Min. Aussenkabine',
        id: '2'
    },
    {
        name: 'Min. Balkonkabine',
        id: '3'
    },
    {
        name: 'Min. Suite',
        id: '4'
    },
];

export const cruisegsPrice: Item[] = [
    {
        name: '500 €',
        id: '500'
    },
    {
        name: '1000 €',
        id: '1000'
    },
    {
        name: '2000 €',
        id: '2000'
    },
    {
        name: '3000 €',
        id: '3000'
    },
    {
        name: '4000 €',
        id: '4000'
    },
    {
        name: '5000 €',
        id: '5000'
    },
];

export const cruiselanguage: Item[] = [
    {
        name: 'Deutsch',
        id: 'de'
    },
    {
        name: 'Englisch',
        id: 'en'
    },
];
